import type { PermissionTuple } from '~/utils/ability'
import type { RouteTo } from '~/utils/rbac'
import type { GuardedTab } from '~/utils/rbacTabs'

/** Chaque onglet est une URL distincte : l'onglet courant est déduit de la route active. */
export type QualityTab = 'lots' | 'articles'

/**
 * Source unique des droits de lecture des sous-onglets Qualité.
 *
 * Consommée par le `staticData.permission` de chaque route d'onglet, par la barre d'onglets, et par
 * `/quality` qui n'est accessible que si l'un d'eux l'est. Un seul endroit à mettre à jour : pas de
 * dérive possible entre l'onglet affiché et la page qu'il ouvre.
 */
export const QUALITY_TAB_PERMISSIONS = {
  lots: ['read', 'quality.search-by-lot.lot-traceability'],
  articles: ['read', 'quality.search-by-article.article-traceability'],
} as const satisfies Record<QualityTab, PermissionTuple>

/** Chaque onglet a forcément une route et un droit de lecture — d'où les champs rendus requis. */
type QualityTabDefinition = GuardedTab<QualityTab> & {
  to: RouteTo
  permission: PermissionTuple
}

/** Ordre de déclaration = ordre d'affichage, et ordre de repli de la redirection `/quality`. */
export const QUALITY_TABS: QualityTabDefinition[] = [
  {
    value: 'lots',
    label: 'Recherche par lot',
    to: '/quality/lots',
    permission: QUALITY_TAB_PERMISSIONS.lots,
  },
  {
    value: 'articles',
    label: 'Recherche par article',
    to: '/quality/articles',
    permission: QUALITY_TAB_PERMISSIONS.articles,
  },
]
